var Marionette = require('marionette')
var App = require('app')
var MapSimple = require('./mapSimple')

// var LeafletSleep = require('leaflet-sleep')

var MapRadiusModule = MapSimple.extend({
  setRadiusIndicator: function (location, radius) {
    if (this.radiusIndicator) this.map.removeLayer(this.radiusIndicator)

    this.radiusIndicator = L.circle(location, radius * 0.65, { fillColor: '#1A8DD6', color: '#1A8DD6', opacity: 0, weight: 2}).addTo(this.map)
  },
  setLocationMarker: function (location) {
    this.locationMarker.setLatLng(location)
  },
  createLocationMarker: function (location, callback) {
    this.locationMarker = this.addMarker(location, {
      id: 'locationMarker',
      mapBoxOptions: {
        draggable: true
      },
      onDragEnd: callback
    })
  },
  registerMapClick: function (callback) {
    function onMapClick (e) {
      callback(e.latlng)
    }

    this.map.on('click', onMapClick)
  }
})

module.exports = MapRadiusModule



// WEBPACK FOOTER //
// ./js/common/mapRadius.js